import { render, staticRenderFns } from "./editEmailTemplate.vue?vue&type=template&id=a3e61fc0&scoped=true&lang=pug"
import script from "./editEmailTemplate.vue?vue&type=script&lang=js"
export * from "./editEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e61fc0",
  null
  
)

/* custom blocks */
import block0 from "./editEmailTemplate.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports